const data = [
    {id: 1, link: '#header', title: 'Home'},
    {id: 2, link: '#about', title: 'About'},
    {id: 3, link: '#portfolio', title: 'Portfolio'},
    {id: 4, link: '#process', title: 'Process'},
    {id: 5, link: '#contact', title: 'Contact'}
    ]

    export default data;